import { Icon } from '@chakra-ui/react';

export const Union = (props) => (
  <Icon viewBox="0 0 16 16" boxSize="16px" color="icon.g1" {...props}>
    <path d="M4 10L6.5 12.5L13 6L12 5L6.5 10.5L5 9L4 10Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2222 1.6H13.3333V0.25C13.3333 0.111929 13.2214 0 13.0833 0H11.8056C11.6675 0 11.5556 0.111929 11.5556 0.25V1.6H4.44444V0.25C4.44444 0.111929 4.33252 0 4.19444 0H2.91667C2.7786 0 2.66667 0.111929 2.66667 0.25V1.6H1.77778C0.791111 1.6 0 2.32 0 3.2V14.4C0 15.28 0.791111 16 1.77778 16H14.2222C15.2 16 16 15.28 16 14.4V3.2C16 2.32 15.2 1.6 14.2222 1.6ZM14.2222 14.4H1.77778V3.4H14.2222V14.4Z"
      fill="#1565BC"
    />
  </Icon>
);
